import { Outlet } from 'react-router-dom'
import EnterpriseLayout from './enterprise-layout'

import '@/global.css'

const EnterpriseProvider = () => {
  const removeStylesheet = (href: string) => {
    const link = document.querySelector(`link[href="${href}"]`)
    if (link) {
      document.body.removeChild(link)
    }
  }
  removeStylesheet('/css/landing.css')
  removeStylesheet('/css/bootstrap.css')
  return (
    <EnterpriseLayout>
      <Outlet />
    </EnterpriseLayout>
  )
}

export default EnterpriseProvider
